module.exports = __webpack_public_path__ + "img/tradition.671ad77.jpg";